export default {
  mobile: "(max-width: 599px)",
  tablet: "(min-width: 600px) and (max-width: 1199px)",
  notdesktop: "(max-width: 1199px)",
  tabletdesktop: "(min-width: 600px)",
  desktop: "(min-width: 1200px)"
};
